import {
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import {
    FormBuilder,

    FormGroup,
    Validators
} from '@angular/forms';
import { MobileAppGroupSummary } from '~/models/administration/mobileAppGroup';
import { MobileAppGroupsService } from '~/services/modules/stocks/administration/mobile-app-groups';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { LayoutManagerService, PORTAL_DATA } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { SharedService } from '~/services/sharedService';
@Component({
    selector: 'app-mobile-app-groups-upsert',
    templateUrl: './upsert.html',
    styleUrls: ['./upsert.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class MobileAppGroupsUpsertComponent implements OnInit, OnDestroy {
    _kendoTabStripPosition = 'left';
    _innerWidth: any;
    _hiddenWindow: any;
    _maximized: any;
    _theme: string;
    _isNew: boolean;
    _form: FormGroup;
    _active: boolean;
    _isAutoGeneratingNumber: boolean;
    _tabEnabled: boolean;
    _currentType: string;
    _invalidForm: boolean;
    _model: MobileAppGroupSummary;
    currentStep = 0;
    _steps : any = [
        { label: 'Enable' },
        { label: 'Group Name' },
        { label: 'Data Sync Mode' },
        { label: 'Transactions' }
    ];
    @ViewChild('kendo_tabstrip_wrapper') navTrigger: ElementRef;
    data: any;

    constructor(
        private _mobileAppGroupsService: MobileAppGroupsService,
        private _fb: FormBuilder,
        private _themeManager: ThemeManagerService,
        private _layoutManager: LayoutManagerService,
        private _layoutComponent: LayoutComponent,
        private _gridLayoutManagerService: GridLayoutManagerService,
        private _sharedService: SharedService,
        // @Inject(PORTAL_DATA) public data: any
    ) {
        this.data = _sharedService.model;
        if (this.data) {
            this._model = this.data.model;
            this._isNew = this.data.model.isNew;
            this._active = true;
        }
        this._themeManager.themeChange.subscribe((data) => {
            this._theme = data;
        });
        this._layoutManager.applyOverly();
    }


    ngOnInit() {
        this._initForm();
    }

    _onStateChanges(e: any) {
        if (e === 'minimized') {
            this._layoutManager.removeOverlay();
        } else {
            this._layoutManager.applyOverly();
        }
    }

    ngOnDestroy() {
        this._layoutManager.removeOverlay();
    }
    _back() {
      this.currentStep--;
      this._currentStepChange();
    }

    _next() {

      this.currentStep++;
      this._currentStepChange();
    }
    _canGoNext: boolean = true;
    _currentStepChange() {
      if (this.currentStep === 0) {
        this.resetSteps();
      }

      if (this.currentStep !== this._steps.length - 1) {
        this._canGoNext = !this._steps[this.currentStep + 1]['disabled'];
      }

      // if (this.currentStep === 1) {
      //   setTimeout(() => {
      //     this._currentBox = 3;
      //   }, 1000);
      // }
    }
    private resetSteps() {

    }
   @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this._innerWidth = window.innerWidth;
        if (this._innerWidth > 450) {
            this._hiddenWindow = 'hidden';
            this._maximized = 'maximized';
        } else {
            this._hiddenWindow = '';
            this._maximized = 'default';
        }
        let windowSize = window.innerWidth;

        if (windowSize <= 991) {
            this._kendoTabStripPosition = 'top';
        } else {
            this._kendoTabStripPosition = 'left';
        }
    }

    _onTabSelect(e: any) {
        this._mobileMenuToggle();
    }

    _mobileMenuToggle() {
        let mobiletabstrip = this.navTrigger.nativeElement.querySelector('ul');
        mobiletabstrip.classList.toggle('visibletab');
    }

    _onSave(e: any) {
        this.submit();
    }

    _onCancel() {
        this._closeForm();
    }

    _closeForm() {
        var closeComponent = {
      response: this._form.value,
      component: 'mobileAppGroups',
      isClosed: true,
    };

    this._gridLayoutManagerService.setGridDataSubjects('mobileAppGroups');
    this._layoutManager.setFromChanged('mobileAppGroups');

    this.ngOnDestroy();
    this._sharedService.closeDialog.emit(closeComponent);
    this._sharedService.model = {};
    this._active = false;
    this.ngOnDestroy();
    }

    _enableOfflineModeChecked(ev: any) {
        const model = this._form.value;
        model.enableOnlineMode = false;
        model.enableOnlineModeSync = false;
        this._form.patchValue({
            enableOnlineMode: false,
            enableOnlineModeSync: false
        });
    }

    _enableOfflineModeWithAuthChecked(ev: any) {
        const model = this._form.value;
        model.enableOnlineMode = false;
        model.enableOnlineModeSync = false;
        this._form.patchValue({
            enableOnlineMode: false,
            enableOnlineModeSync: false
        });
    }

    _enableOnlineModeChecked(ev: any) {
        const model = this._form.value;
        model.enableOfflineMode = false;
        model.enableOfflineModeWithAuth = false;
        this._form.patchValue({
            enableOfflineMode: false,
            enableOfflineModeWithAuth: false
        });
    }

    _enableOnlineModeSyncChecked(ev: any) {
        const model = this._form.value;
        model.enableOfflineMode = false;
        model.enableOfflineModeWithAuth = false;
        this._form.patchValue({
            enableOfflineMode: false,
            enableOfflineModeWithAuth: false
        });
    }

    private _initForm() {
        this._form = this._fb.group({
            name: [this._model ? this._model.name : null, Validators.required],
            enableGroup: [this._model ? this._model.enableGroup : false],
            enableOfflineMode: [this._model ? this._model.enableOfflineMode : false],
            enableOfflineModeWithAuth: [this._model ? this._model.enableOfflineModeWithAuth : false],
            enableOnlineMode: [this._model ? this._model.enableOnlineMode : false],
            enableOnlineModeSync: [this._model ? this._model.enableOnlineModeSync : false],
            chooseReceive: [this._model ? this._model.chooseReceive : false],
            chooseMove: [this._model ? this._model.chooseMove : false],
            choosePhysicalInventory: [this._model ? this._model.choosePhysicalInventory : false],
            chooseDispose: [this._model ? this._model.chooseDispose : false],
            chooseIssue: [this._model ? this._model.chooseIssue : false],
            choosePack: [this._model ? this._model.choosePack : false],
            chooseShip: [this._model ? this._model.chooseShip : false],
            chooseReturn: [this._model ? this._model.chooseReturn : false],
            chooseRoute: [this._model ? this._model.chooseRoute : false],
            chooseCheckout: [this._model ? this._model.chooseCheckout : false],
            chooseCheckin: [this._model ? this._model.chooseCheckin : false],
            chooseAssign: [this._model ? this._model.chooseAssign : false],
            chooseReservation: [this._model ? this._model.chooseReservation : false],
            choosePerformMaintenance: [this._model ? this._model.choosePerformMaintenance : false],
            isAsset: [this._model ? this._model.isAsset : false]
        });
    }

    private submit = () => {
        if (this._form.invalid) {
            this._invalidForm = true;
        } else {
            this._invalidForm = false;

            if (this._form.value.enableGroup == null) { this._form.value.enableGroup = false; }
            if (this._form.value.enableOfflineMode == null) { this._form.value.enableOfflineMode = false; }
            if (this._form.value.enableOfflineModeWithAuth == null) { this._form.value.enableOfflineModeWithAuth = false; }
            if (this._form.value.enableOnlineMode == null) { this._form.value.enableOnlineMode = false; }
            if (this._form.value.enableOnlineModeSync == null) { this._form.value.enableOnlineModeSync = false; }
            if (this._form.value.chooseReceive == null) { this._form.value.chooseReceive = false; }
            if (this._form.value.chooseMove == null) { this._form.value.chooseMove = false; }
            if (this._form.value.choosePhysicalInventory == null) { this._form.value.choosePhysicalInventory = false; }
            if (this._form.value.chooseDispose == null) { this._form.value.chooseDispose = false; }
            if (this._form.value.chooseIssue == null) { this._form.value.chooseIssue = false; }
            if (this._form.value.choosePack == null) { this._form.value.choosePack = false; }
            if (this._form.value.chooseShip == null) { this._form.value.chooseShip = false; }
            if (this._form.value.chooseReturn == null) { this._form.value.chooseReturn = false; }
            if (this._form.value.chooseRoute == null) { this._form.value.chooseRoute = false; }
            if (this._form.value.chooseCheckout == null) { this._form.value.chooseCheckout = false; }
            if (this._form.value.chooseCheckin == null) { this._form.value.chooseCheckin = false; }
            if (this._form.value.chooseAssign == null) { this._form.value.chooseAssign = false; }
            if (this._form.value.chooseReservation == null) { this._form.value.chooseReservation = false; }
            if (this._form.value.choosePerformMaintenance == null) { this._form.value.choosePerformMaintenance = false; }
            if (this._form.value.isAsset == null) { this._form.value.isAsset = false; }

            if (this._form.value.enableOnlineModeSync == true) { this._form.value.enableOnlineMode = true; }
            if (this._form.value.enableOfflineModeWithAuth == true) { this._form.value.enableOfflineModeW = true; }

            const model = this._form.value;
            if (!this._isNew) {
                this._mobileAppGroupsService
                    .updateMobileAppGroup(this._model.id, model)
                    
                    .subscribe(() => {
                        this._closeForm();
                    });
            } else {
                this._mobileAppGroupsService
                    .createMobileAppGroup(model)
                    
                    .subscribe((response: any) => {
                        if (response != null && response['message'] != null) {
                            this._layoutComponent.openPopup({
                                title: 'Alert',
                                message: response['message'],
                                withoutConfirm: true
                            });
                            if (response['close'] != null) {
                                if (response['close'] == true) {
                                    this._closeForm();
                                } else {
                                    return;
                                }
                            }
                        }
                        this._closeForm();
                    });
            }
        }
    }
}
